import React from "react";

export default function PresentialDescription({ className }) {
  return (
    <svg
      width="120"
      height="34"
      viewBox="0 0 120 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.5"
        y="0.5"
        width="110"
        height="33"
        rx="16.5"
        fill="#29394D"
        fill-opacity="0.7"
        stroke="white"
      />
      <path
        d="M20.7123 20.1283L17 23.8406L13.2877 20.1283C12.5534 19.3941 12.0534 18.4586 11.8509 17.4402C11.6483 16.4218 11.7523 15.3662 12.1496 14.4069C12.547 13.4476 13.2199 12.6277 14.0833 12.0508C14.9466 11.4739 15.9617 11.166 17 11.166C18.0384 11.166 19.0534 11.4739 19.9167 12.0508C20.7801 12.6277 21.453 13.4476 21.8504 14.4069C22.2477 15.3662 22.3517 16.4218 22.1491 17.4402C21.9466 18.4586 21.4466 19.3941 20.7123 20.1283ZM17 18.7493C17.6188 18.7493 18.2123 18.5035 18.6499 18.0659C19.0875 17.6283 19.3333 17.0348 19.3333 16.416C19.3333 15.7971 19.0875 15.2036 18.6499 14.7661C18.2123 14.3285 17.6188 14.0826 17 14.0826C16.3812 14.0826 15.7877 14.3285 15.3501 14.7661C14.9125 15.2036 14.6667 15.7971 14.6667 16.416C14.6667 17.0348 14.9125 17.6283 15.3501 18.0659C15.7877 18.5035 16.3812 18.7493 17 18.7493ZM17 17.5826C16.6906 17.5826 16.3938 17.4597 16.175 17.2409C15.9563 17.0221 15.8333 16.7254 15.8333 16.416C15.8333 16.1066 15.9563 15.8098 16.175 15.591C16.3938 15.3722 16.6906 15.2493 17 15.2493C17.3094 15.2493 17.6062 15.3722 17.825 15.591C18.0438 15.8098 18.1667 16.1066 18.1667 16.416C18.1667 16.7254 18.0438 17.0221 17.825 17.2409C17.6062 17.4597 17.3094 17.5826 17 17.5826Z"
        fill="white"
      />
    </svg>
  );
}
